<template>
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.707 5.293a1 1 0 0 1 0 1.414l-7.25 7.25a1 1 0 0 1-1.414 0l-3.25-3.25A1 1 0 1 1 6.293 9.293l2.543 2.543 6.543-6.543a1 1 0 0 1 1.328 0z"
        />
    </svg>
</template>

<script>
export default {
    name: 'CheckIcon'
};
</script>
